import * as Common from "../../commons/common"

export class SearchCondition {
  publish_at_from: string = ""
  publish_at_to: string = ""
  std_deadline_at_from: string = ""
  std_deadline_at_to: string = ""
  final_deadline_at_from: string = ""
  final_deadline_at_to: string = ""
  subject_code: string = null
  nendo: number = null
  page: number = 1
  row_count: number =  100
}

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: string
  subject_code: string
  report_no: number
  sheet_name: string
  publish_at: string
  std_deadline_at: string
  final_deadline_at: string
  student_count: number
  submitted_count: number
  submitted_percent: number
  not_submitted_count: number

  constructor(x: any){
    this.id = x.id;
    this.sheet_code = x.sheet_code;
    this.nendo = x.nendo;
    this.subject_code = x.subject_code;
    this.report_no = x.report_no;
    this.sheet_name = x.sheet_name;
    this.publish_at = x.publish_at ? Common.formatDate(x.publish_at, "Y年M月D日") : null;
    this.std_deadline_at = x.std_deadline_at ? Common.formatDate(x.std_deadline_at, "Y年M月D日") : null;
    this.final_deadline_at = x.final_deadline_at ? Common.formatDate(x.final_deadline_at, "Y年M月D日") : null;
    this.student_count = x.student_count;
    this.submitted_count = x.submitted_count;
    this.submitted_percent = this.submitted_count == 0 || this.student_count == 0 ? 0 : Math.floor(this.submitted_count * 100 / this.student_count);
    this.not_submitted_count = x.student_count - x.submitted_count;
  }
}